export const carOwnersLinks = {
    android: "https://play.google.com/store/apps/details?id=com.cyhermes.parizzo",
    ios: "https://apps.apple.com/us/app/parizzo-provider/id1289069862",
}

export const passengerLinks = {
    android: "https://play.google.com/store/apps/details?id=com.cyhermes.parizzoRiderApp",
    ios: "https://apps.apple.com/us/app/parizzo-passenger/id1303470517",
}